import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalBasicComponent implements OnInit {
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Output() onHideShowEvent: EventEmitter<any>;

  public visible = false;
  public visibleAnimate = false;

  constructor() { this.onHideShowEvent = new EventEmitter<any>();}

  ngOnInit() {

  }

  public show(): void {
    this.visible = true;
    this.onHideShowEvent.emit(true);
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    this.onHideShowEvent.emit(false);
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

}
